import React from "react";
import { ThemedText } from "@/components/ThemedText";

interface VisuallyHiddenHeadingProps {
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  children: React.ReactNode;
}

export function VisuallyHiddenHeading({
  level = 1,
  children,
}: VisuallyHiddenHeadingProps) {
  return (
    <ThemedText
      accessibilityRole="header"
      aria-level={level}
      style={{
        position: "absolute",
        width: 1,
        height: 1,
        overflow: "hidden",
        top: 0,
        left: 0,
        margin: -1,
        padding: 0,
      }}
    >
      {children}
    </ThemedText>
  );
}
